module.exports = __webpack_public_path__ + "img/deepwater-side.7af8824c.png";